import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Logo from "./Logo";

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="w-full bg-white">
      <div className="mx-auto flex flex-col md:flex-row md:h-[68.7px] w-full max-w-page items-center justify-between gap-3 md:gap-0 px-5 md:px-[42px] py-4 md:py-[15px]">
        <div className="shrink-0 order-1 md:order-none">
          <Logo />
        </div>
        <p className="font-clash text-[11px] md:text-[13px] text-[#8e8e8e] tracking-[-0.02em] whitespace-pre order-3 md:order-none">
          {t("footer.rights")}
        </p>
        <div className="flex items-center shrink-0 order-2 md:order-none">
          <Link to="/privacy" className="font-clash text-[11px] md:text-[13px] text-[#8e8e8e] hover:text-[#010f1f] tracking-[-0.02em] whitespace-nowrap px-[8px] md:px-[11px] py-[8px] md:py-[11px]">
            {t("footer.privacy")}
          </Link>
          <span className="font-clash text-[11px] md:text-[13px] text-[#8e8e8e] tracking-[-0.02em] px-[8px] md:px-[11px]">|</span>
          <Link to="/terms" className="font-clash text-[11px] md:text-[13px] text-[#8e8e8e] hover:text-[#010f1f] tracking-[-0.02em] whitespace-nowrap px-[8px] md:px-[11px] py-[8px] md:py-[11px]">
            {t("footer.terms")}
          </Link>
        </div>
      </div>
    </footer>
  );
}
